import React, { useState } from 'react';
import saLogoAi from '../../assets/sa_logo_ai.svg';
import { useTheme } from './Theme';
import { readTenantBranding } from './tenantBranding';

interface SidebarBrandProps {
  collapsed: boolean;
  onClick: () => void;
}

function getBrandInitials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  const caps = name.match(/[A-Z]/g);
  if (caps && caps.length >= 2) return `${caps[0]}${caps[1]}`;
  return name.slice(0, 2).toUpperCase();
}

const SidebarBrand: React.FC<SidebarBrandProps> = ({ collapsed, onClick }) => {
  const { theme } = useTheme();
  const isLight = theme === 'white';
  const { name: tenantName, logoUrl: tenantLogoUrl } = readTenantBranding();
  const [logoSrc, setLogoSrc] = useState(tenantLogoUrl || '');
  const brandLabel = tenantName || 'SelficAI';
  const fullBrandLabel = `${brandLabel} Control Plane`;
  const initials = getBrandInitials(brandLabel);
  const hasTenantLogo = Boolean(logoSrc && logoSrc !== saLogoAi);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex h-full w-full items-center focus:outline-none ${
        collapsed ? 'justify-center' : 'gap-2.5'
      }`}
      aria-label={`Go to home, ${fullBrandLabel}`}
      title={fullBrandLabel}
    >
      <span className="portal-sidebar-mark flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-full text-[10px] font-semibold tracking-wide">
        {hasTenantLogo ? (
          <img
            src={logoSrc}
            alt={brandLabel}
            className="h-full w-full object-cover object-center"
            onError={() => {
              console.warn('[SidebarBrand] tenant logo failed to load; using initials');
              setLogoSrc('');
            }}
          />
        ) : (
          initials
        )}
      </span>

      {!collapsed && (
        <span className="min-w-0 flex-1 text-left">
          <span
            className={`block truncate text-[13px] font-medium leading-5 ${
              isLight ? 'text-neutral-700' : 'text-neutral-200'
            }`}
          >
            {brandLabel}
          </span>
          <span
            className={`block truncate text-[10px] font-normal leading-4 ${
              isLight ? 'text-neutral-400' : 'text-neutral-500'
            }`}
          >
            Control plane
          </span>
        </span>
      )}
    </button>
  );
};

export default SidebarBrand;
